/**
 * View component for /certificate-templates/:certificateTemplateId/update
 *
 * Updates a single certificate-template from a copy of the selcted certificate-template
 * as defined in the certificate-template reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as certificateTemplateActions from '../certificateTemplateActions';
import * as contentModuleActions from '../../contentModule/contentModuleActions';

// import global components
import AuthoringLayout from '../../admin/components/AuthoringLayout.js.jsx';
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from "../../../global/components/routing/Breadcrumbs.js.jsx";
import Video from "../../../global/components/helpers/Video.js.jsx";
import videoUtils from "../../../global/utils/videoUtils.js";

// import module components
import CertificateTemplateForm from '../components/CertificateTemplateForm.js.jsx';

// import certificate-template css modules
import certificateTemplateStyles from '../certificateTemplateModuleStyles.css';

class AdminUpdateCertificateTemplate extends Base {
  constructor(props) {
    super(props);
    const { selectedCertificateTemplate, certificateTemplateMap } = this.props;
    this.state = {
      certificateTemplate: certificateTemplateMap[selectedCertificateTemplate.id] ? _.cloneDeep(certificateTemplateMap[selectedCertificateTemplate.id]) : {}
      // NOTE: we don't want to change the store, just make changes to a copy
      , formHelpers: {
        bottomRight: 'useSponsor'
      }
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(certificateTemplateActions.fetchSingleIfNeeded(match.params.certificateTemplateId)).then((action) => {
      if(action.success) {
        dispatch(contentModuleActions.fetchSingleIfNeeded(action.item._contentModule));
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    const { selectedCertificateTemplate, certificateTemplateMap } = nextProps;
    this.setState({
      certificateTemplate: certificateTemplateMap[selectedCertificateTemplate.id] ? _.cloneDeep(certificateTemplateMap[selectedCertificateTemplate.id]) : {}
      //we don't want to actually change the store's certificateTemplate, just use a copy
      , formHelpers: {
        bottomRight: certificateTemplateMap[selectedCertificateTemplate.id] && certificateTemplateMap[selectedCertificateTemplate.id].overrideSponsorLogo ? 'overrideSponsor' : 'useSponsor'
      }
    })
  }

  _handleFormChange(e) {
    let newState = _.update( this.state, e.target.name, function() {
      return e.target.value;
    });

    this.setState(newState);
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    let newCertTemplate = {...this.state.certificateTemplate}
    if(this.state.certificateTemplate.bottomRightStatus !== 'overrideSponsorLogo') {
      newCertTemplate.bottomRightLogoUrl = null
    } 
    dispatch(certificateTemplateActions.sendUpdateCertificateTemplate(newCertTemplate)).then(action => {
      if(action.success) {
        history.push(`/admin/certificate-templates/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert(`ERROR: ${action.error}`);
      }
    });
  }

  render() {
    const {
      certificateTemplateMap
      , location
      , match
      , selectedCertificateTemplate
    } = this.props;
    const { certificateTemplate, formHelpers } = this.state;

    const isEmpty = (
      !certificateTemplate
      || certificateTemplate._id === null
      || certificateTemplate._id === undefined
    );
    return  (
      <div className="flex">
        <section className="section">
          <div className="yt-container">
            <Breadcrumbs links={location.state.breadcrumbs} />
          </div>
          {isEmpty ?
            (selectedCertificateTemplate.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
            :
            <CertificateTemplateForm
              cancelLink={`/admin/certificate-templates/${certificateTemplate._id}`}
              certificateTemplate={certificateTemplate}
              formHelpers={formHelpers}
              formTitle="Update Certificate Template"
              formType="update"
              handleFormChange={this._handleFormChange}
              handleFormSubmit={this._handleFormSubmit}
            />
          }
        </section>
      </div>
    )
  }
}

AdminUpdateCertificateTemplate.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    certificateTemplateMap: store.certificateTemplate.byId
    , selectedCertificateTemplate: store.certificateTemplate.selected
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminUpdateCertificateTemplate)
);



// WEBPACK FOOTER //
// modules/certificateTemplate/views/AdminUpdateCertificateTemplate.js.jsx